import { put, select, takeEvery } from "redux-saga/effects";
import { delay } from "redux-saga";
import { touchStore } from "./actions";
import { setLocations } from "../minWage/actions";
import { MINWAGE_SET_LOCATIONS } from "../minWage/actionTypes";
import { devEnabled } from "./selectors";

// Create array of test locations
let testLocations = null;

function* setLocationsData(data) {
  if (!testLocations) {
    testLocations = [];
    for (let i = 1; i < 30000; i += 1) {
      testLocations.push({
        id: i,
        customerID: 1,
        active: true,
        address1: null,
        address2: null,
        address3: null,
        attention: null,
        city: "Tinley Park",
        county: "Cook",
        country: "US",
        name: `Test Cook County ${i}`,
        placeID: "afafda34sg",
        state: "IL",
        zip: "22222",
        wages: {
          tipped: {
            id: 1181,
            active: true,
            context: null,
            effectiveDate: "2017-01-01",
            expireDate: null,
            industry: "Standard",
            jurisdiction: {
              country: "US",
              name: "Illinois",
              state: "IL",
              type: "State"
            },
            lawCitation: "820 ILCS 105/4(c)",
            links: [],
            maximumCompanyRevenue: null,
            maximumEmployeeCount: null,
            minimumCompanyRevenue: null,
            minimumEmployeeCount: null,
            notes: null,
            regulationCitation: null,
            subIndustry: null,
            subSubIndustry: null,
            subTopic: "Tipped Minimum Wage",
            topic: "Gratuities",
            wage: 4.95 + i / 100
          },
          standard: {
            id: 1196,
            active: true,
            context: null,
            effectiveDate: "2010-07-01",
            expireDate: null,
            industry: "Standard",
            jurisdiction: {
              country: "US",
              name: "Illinois",
              state: "IL",
              type: "State"
            },
            lawCitation: "820 ILCS 105/4(a)(1)",
            links: [],
            maximumCompanyRevenue: null,
            maximumEmployeeCount: null,
            minimumCompanyRevenue: null,
            minimumEmployeeCount: null,
            notes: null,
            regulationCitation: null,
            subIndustry: null,
            subSubIndustry: null,
            subTopic: "Wage Rate",
            topic: "Wage Rate",
            wage: 8.25 + i / 100
          }
        }
      });
    }

    yield put(setLocations(testLocations));
  }
}

function* touch() {
  while (true) {
    yield delay(1000);
    yield put(touchStore());
  }
}

export default function* devSaga() {
  const enabled = yield select(devEnabled);
  if (!enabled) {
    return;
  }
  console.log("***** Dev Saga *****");
  yield touch();
  yield takeEvery(MINWAGE_SET_LOCATIONS, setLocationsData);
}
